import { Image, FileText, Type, Settings, Dock } from "lucide-react";

export const CustomizeShopCategories = [
  {
    label: "Header & Favicon",
    value: "Header & Favicon",
    icon: <Dock size={25} />,
  },
  { label: "Banners", value: "Banners", icon: <Image size={25} /> },
  { label: "Pages", value: "Pages", icon: <FileText size={25} /> },
  { label: "Fonts", value: "Fonts", icon: <Type size={25} /> },
  { label: "Advanced", value: "Advanced", icon: <Settings size={25} /> },
];
